import styled from 'styled-components';
import media from 'src/styles/Media.styled';
import { 
    PRIMARY_FONT_COLOR,
    SECONDARY_FONT_COLOR,
    RED_FONT_COLOR,
    DISABLED_FONT_COLOR,
    FONT_FAMILY_DEMI,
    SMALL_TEXT_PX,
    SEMANTIC_TEXT_SMALL_PX,
    FONT_FAMILY_REGULAR,
} from 'src/styles/fonts/MCFontConstants';

export const LeftColorCode = styled.div`
    border-left: 5px solid ${({isExpired}) => isExpired ? RED_FONT_COLOR : DISABLED_FONT_COLOR};
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    background-color: ${RED_FONT_COLOR};
    border-top-left-radius: 6px;
    border-bottom-left-radius: 6px;
`;

export const ContentContainer = styled.div`
    display: flex;
    flex-direction: column;
    padding: 15px 22px 15px 22px;
    font-family: ${({ fontFamily }) => fontFamily ? fontFamily : FONT_FAMILY_DEMI};
    color: #4f4f4f;
    width: 100%;
    box-sizing: border-box;
    position: relative;
    z-index: 1;

    ${media.mobileDevice`
        padding: 12px 16px 12px 16px;
    `}
`;

export const HeaderSection = styled.div`
    display: flex;
    flex-direction: column;
    margin-bottom: 8px;
`;

export const AccountName = styled.div`
    color: ${({ color }) => color ? color : PRIMARY_FONT_COLOR};
    font-size: ${SMALL_TEXT_PX};
    font-family: ${({ fontFamily }) => fontFamily ? fontFamily : FONT_FAMILY_REGULAR};
    font-weight: ${({ fontWeight }) => fontWeight ? fontWeight : '300'};
    line-height: 24px;
    margin-bottom: 0;
`;

export const AccountNumber = styled.div`
    color: ${({ color }) => color ? color : PRIMARY_FONT_COLOR};
    font-size: ${SMALL_TEXT_PX};
    font-family: ${({ fontFamily }) => fontFamily ? fontFamily : FONT_FAMILY_REGULAR};
    font-weight: ${({ fontWeight }) => fontWeight ? fontWeight : '300'};
    line-height: 24px;
    margin-top: 0;
`;

export const BodySection = styled.div`
    display: flex;
    flex-direction: column;
    margin: 6px 0;
`;

export const FieldRow = styled.div`
    display: flex;
    align-items: flex-start;
    margin-bottom: ${({ noMargin }) => (noMargin ? '0' : '4px')};
    line-height: 21px;
`;

export const FieldLabel = styled.span`
    color: ${({ color }) => color ? color : PRIMARY_FONT_COLOR};
    font-size: ${({ fontSize }) => fontSize ? fontSize : SMALL_TEXT_PX};
    font-weight: ${({ fontWeight }) => fontWeight ? fontWeight : '300'};
    font-family: ${({ fontFamily }) => fontFamily ? fontFamily : FONT_FAMILY_REGULAR};
    margin-right: 6px;
    flex-shrink: 0;
`;

export const FieldValue = styled.span`
    color: ${({ color }) => color ? color : PRIMARY_FONT_COLOR};
    font-size: ${({ fontSize }) => fontSize ? fontSize : SMALL_TEXT_PX};
    font-weight: ${({ fontWeight }) => fontWeight ? fontWeight : '300'};
    font-family: ${({ fontFamily }) => fontFamily ? fontFamily : FONT_FAMILY_REGULAR};
    flex: 1;
    word-break: break-word;
    line-height: 21px;
`;

export const BottomSection = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    gap: 8px;
    margin-top: 8px;
    padding-top: 8px;
`;

export const BottomField = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
    ${({ centered }) => centered && `
        text-align: center;
        align-items: center;
    `}
`;

export const BottomLabel = styled.div`
    color: ${SECONDARY_FONT_COLOR};
    font-size: ${SEMANTIC_TEXT_SMALL_PX};
    font-family: ${({ fontFamily }) => fontFamily ? fontFamily : FONT_FAMILY_REGULAR};
    font-weight: ${({ fontWeight }) => fontWeight ? fontWeight : '300'};
    line-height: 14px;
`;

export const BottomValue = styled.div`
    color: ${({ hasWarning }) => (hasWarning ? RED_FONT_COLOR : PRIMARY_FONT_COLOR)};
    font-size: ${SMALL_TEXT_PX};
    font-family: ${({ fontFamily }) => fontFamily ? fontFamily : FONT_FAMILY_REGULAR};
    font-weight: ${({ fontWeight }) => fontWeight ? fontWeight : '300'};
    line-height: 18px;
    display: flex;
    align-items: center;
    gap: 6px;
    ${({ centered }) => centered && `
        justify-content: center;
    `}
`;

export const WarningIcon = styled.img`
    width: 20px;
    height: 20px;
    flex-shrink: 0;
`;
